var _a;
import purInDetail from "../page/purchasein/Detail.vue";
import purOrderDetail from "../page/purchaseorder/Detail.vue";
import deliverDetail from "../page/deliver/Detail.vue";
import entrustedDeliverDetail from "../page/entrustedDelivery/Detail.vue";
import purBackDetail from "../page/purchaseback/Detail.vue";
import AccountDetail from "../page/accountcheck/Detail.vue";
import PaymentDetail from "../page/payment/PaymentOrderDetail.vue";
import QuoteDetail from "../page/quotedprice/Detail.vue";
import PriceSetDetail from "../page/pricesetting/Detail.vue";
import PurSortingDetail from "../page/purchasesorting/Detail.vue";
import StockInitDetail from "../page/stockInit/Detail.vue";
import IncomeOrderDetail from "../page/incomeorder/Detail.vue";
import BusinessGoodsPriceDetail from "../page/businessgoodsprice/Detail.vue";
import ShopAfterSalesDetail from "../page/shopAfterSales/Detail.vue";
import SeeBindLicenses from "../page/good/SeeBindLicenses.vue";
import PurToStockDetail from "../page/purchase/Detail.vue";
import DetailRichText from '../page/notify/DetailRichText.vue';
import PlanOrderForUpperSupDetail from '../page/planOrderForUpperSup/Detail.vue';
import PurchaseOrderForUpperSupDetail from '../page/purchaseOrderForUpperSup/Detail.vue';
import PurchaseRefundForUpperSupDetail from '../page/purchaseRefundForUpperSup/Detail.vue';
import UpperSupCheckDetail from '../page/uppersupcheck/Detail.vue';
import UpperPaymentDetail from "../page/upperPayment/PaymentOrderDetail.vue";
import SaleManDetail from "../page/client/SaleManDetail.vue";
import BindStoreDetail from "../page/user/BindStoreDetail.vue";
import AnasyleDetails from "../page/operationReport/LossAnasyleDetails.vue";
export var EBillType;
(function (EBillType) {
    EBillType[EBillType["PurOrder"] = 1] = "PurOrder";
    EBillType[EBillType["PurIn"] = 2] = "PurIn";
    EBillType[EBillType["PurBack"] = 3] = "PurBack";
    EBillType[EBillType["Deliver"] = 4] = "Deliver";
    EBillType[EBillType["Invite"] = 5] = "Invite";
    EBillType[EBillType["Good"] = 6] = "Good";
    EBillType[EBillType["Supplier"] = 7] = "Supplier";
    EBillType[EBillType["Quote"] = 8] = "Quote";
    EBillType[EBillType["PriceSet"] = 9] = "PriceSet";
    EBillType[EBillType["Account"] = 10] = "Account";
    EBillType[EBillType["Payment"] = 11] = "Payment";
    EBillType[EBillType["PurSorting"] = 12] = "PurSorting";
    EBillType[EBillType["StockInit"] = 13] = "StockInit";
    EBillType[EBillType["IncomeOrder"] = 14] = "IncomeOrder";
    EBillType[EBillType["BusinessGoodsPrice"] = 15] = "BusinessGoodsPrice";
    EBillType[EBillType["ShopAfterSales"] = 16] = "ShopAfterSales";
    EBillType[EBillType["DeliveryOrderDetailDocument"] = 18] = "DeliveryOrderDetailDocument";
    EBillType[EBillType["DeliveryOrderAdjustAppointmentDeliveryTime"] = 52] = "DeliveryOrderAdjustAppointmentDeliveryTime";
    EBillType[EBillType["DetailRichText"] = 160] = "DetailRichText";
    EBillType[EBillType["PlanOrderForUpperSup"] = 161] = "PlanOrderForUpperSup";
    EBillType[EBillType["PurchaseOrderForUpperSup"] = 162] = "PurchaseOrderForUpperSup";
    EBillType[EBillType["PurchaseRefundForUpperSup"] = 163] = "PurchaseRefundForUpperSup";
    EBillType[EBillType["PurToStock"] = 164] = "PurToStock";
    EBillType[EBillType["UpperSupCheck"] = 165] = "UpperSupCheck";
    EBillType[EBillType["UpperPaymentDetail"] = 166] = "UpperPaymentDetail";
    EBillType[EBillType["AnasyleDetails"] = 167] = "AnasyleDetails";
    EBillType[EBillType["SaleManDetail"] = 168] = "SaleManDetail";
    EBillType[EBillType["BindStoreDetail"] = 169] = "BindStoreDetail";
    EBillType[EBillType["EntrustedDeliver"] = 170] = "EntrustedDeliver";
})(EBillType || (EBillType = {}));
export var EMessageTypeConfig = (_a = {},
    _a[EBillType.PurOrder] = {
        comp: purOrderDetail,
        title: "订货单详情",
        amountFiled: "order_detail_amount"
    },
    _a[EBillType.PurIn] = {
        comp: purInDetail,
        title: "入库单详情",
        amountFiled: "order_detail_inamount"
    },
    _a[EBillType.PurBack] = {
        comp: purBackDetail,
        title: "退货单详情",
        amountFiled: "order_detail_inamount"
    },
    _a[EBillType.Deliver] = {
        comp: deliverDetail,
        title: "送货单详情",
        amountFiled: "order_detail_oamount"
    },
    _a[EBillType.Account] = {
        comp: AccountDetail,
        title: "对账单详情",
    },
    _a[EBillType.Payment] = {
        comp: PaymentDetail,
        title: "付款单详情",
    },
    _a[EBillType.Quote] = {
        comp: QuoteDetail,
        title: "报价详情",
    },
    _a[EBillType.PriceSet] = {
        comp: PriceSetDetail,
        title: "定价详情",
    },
    _a[EBillType.PurSorting] = {
        comp: PurSortingDetail,
        title: "分拣单详情"
    },
    _a[EBillType.StockInit] = {
        comp: StockInitDetail,
        title: "期初单详情"
    },
    _a[EBillType.IncomeOrder] = {
        comp: IncomeOrderDetail,
        title: "损溢单详情"
    },
    _a[EBillType.BusinessGoodsPrice] = {
        comp: BusinessGoodsPriceDetail,
        title: "销售价格单详情"
    },
    _a[EBillType.ShopAfterSales] = {
        comp: ShopAfterSalesDetail,
        title: "售后工单详情"
    },
    _a[EBillType.DeliveryOrderDetailDocument] = {
        comp: SeeBindLicenses,
        title: "查看证照 "
    },
    _a[EBillType.DeliveryOrderAdjustAppointmentDeliveryTime] = {
        comp: deliverDetail,
        title: "送货单详情 "
    },
    _a[EBillType.DetailRichText] = {
        comp: DetailRichText,
        title: "消息详情"
    },
    _a[EBillType.PlanOrderForUpperSup] = {
        comp: PlanOrderForUpperSupDetail,
        title: "采购计划详情"
    },
    _a[EBillType.PurchaseOrderForUpperSup] = {
        comp: PurchaseOrderForUpperSupDetail,
        title: "采购订货详情"
    },
    _a[EBillType.PurchaseRefundForUpperSup] = {
        comp: PurchaseRefundForUpperSupDetail,
        title: "采购退货详情"
    },
    _a[EBillType.PurToStock] = {
        comp: PurToStockDetail,
        title: '采购入库详情'
    },
    _a[EBillType.UpperSupCheck] = {
        comp: UpperSupCheckDetail,
        title: "供应商对账单详情"
    },
    _a[EBillType.UpperPaymentDetail] = {
        comp: UpperPaymentDetail,
        title: "供应付款单详情"
    },
    _a[EBillType.AnasyleDetails] = {
        comp: AnasyleDetails,
        title: "损耗分析图"
    },
    _a[EBillType.SaleManDetail] = {
        comp: SaleManDetail,
        title: "查看绑定用户"
    },
    _a[EBillType.BindStoreDetail] = {
        comp: BindStoreDetail,
        title: "查看绑定门店"
    },
    _a[EBillType.EntrustedDeliver] = {
        comp: entrustedDeliverDetail,
        title: "委托送货单详情",
        amountFiled: "order_detail_oamount"
    },
    _a);
